/**
 * @name BackupTabs
 * @description Configuración de perfil del usuario
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Layout, MUI } from '@tycommon/styles';

// Components
import {
    Backup,
    BackupAssignments
} from '../../components';

const a11yProps = (index) => {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
};

const TabPanel = (props) => {
    const { active, children } = props;
    return ((active) && (<div role="tabpanel">{children}</div>));
};

TabPanel.propTypes = {
    active: PropTypes.any.isRequired,
    children: PropTypes.node.isRequired
};

class BackupTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 0,
        };
    }

    changeTab = (tab) => {
        this.setState({ selectedTab: tab });
    }

    changeIndexTab = (index) => {
        this.setState({ selectedTab: index });
    }

    componentDidMount() {
    }

    render() {
        const {
            selectedTab,
        } = this.state;

        return (
            <>
                <Layout.Content>
                    <Styled.TabsWrapper>
                        <MUI.Tabs
                            value={selectedTab}
                            onChange={(event, tab) => this.changeTab(tab)}
                        >
                            {/* Asignar backup */}
                            <MUI.Tab value={0} wrapped label={i18n.t('BackupSettings.assignBackup')} {...a11yProps(0)} />
                            {/* Asignaciones de backup */}
                            <MUI.Tab value={1} wrapped label={i18n.t('BackupSettings.backupAssignments')} {...a11yProps(1)} />
                        </MUI.Tabs>

                        <MUI.TabsSwipeable
                            index={selectedTab}
                            onChangeIndex={this.changeIndexTab}
                            slideStyle={{ overflow: 'visible' }}
                        >

                            {/* Asignar backup */}
                            <TabPanel active={selectedTab === 0} index={0}>
                                <Styled.TabContent>
                                    <Backup />
                                </Styled.TabContent>
                            </TabPanel>

                            {/* Asignaciones de backup */}
                            <TabPanel active={selectedTab === 1} index={1}>
                                <Styled.TabContent>
                                    <BackupAssignments />
                                </Styled.TabContent>
                            </TabPanel>

                        </MUI.TabsSwipeable>
                    </Styled.TabsWrapper>
                </Layout.Content>
            </>
        );
    }
}

BackupTabs.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 500px;
`;

Styled.TabContent = styled.div`
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
`;

export default BackupTabs;
